export function initKakao() {
  if (!window.Kakao) return;

  if (!window.Kakao.isInitialized()) {
    window.Kakao.init(process.env.REACT_APP_KAKAO_JS_KEY);
    console.log("[KAKAO] initialized");
  }
}


export async function loginWithKakao() {
  return new Promise((resolve, reject) => {
    window.Kakao.Auth.login({
      scope: "profile_nickname, account_email",
      success: function (authObj) {
        resolve(authObj.access_token);
      },
      fail: function (err) {
        reject(err);
      },
    });
  });
}
